import { z } from "zod";
import { bedtimePublicationGenerationCommandSchema } from "./story.js";
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
const micros = z.number().int().nonnegative();
export const bedtimeRepresentativeProofEvidenceV1Schema = z
    .object({
    zeroSpendCompilationDigestSha256: digest,
    studioPlanPreviewDigestSha256: digest,
    existingArtProofDigestSha256: digest,
    truthBoundary: z.literal("SERVER_COMPOSITION_AND_REFERENCE_DIAGNOSTICS_NOT_FINAL_ART_OR_HUMAN_APPROVAL"),
})
    .strict();
/** A reviewable offer; GET does not reserve credits or dispatch a provider. */
export const bedtimeRepresentativeProofOfferV1Schema = z
    .object({
    contract: z.literal("BEDTIME_REPRESENTATIVE_PROOF_OFFER_V1"),
    bookId: z.string().trim().min(1).max(240),
    bookRevision: z.number().int().nonnegative(),
    planDigestSha256: digest,
    providerDispatchAuthorized: z.literal(false),
    quote: z
        .object({
        quoteId: z.string().trim().min(1).max(200),
        quotedCostMicros: micros,
        currency: z.literal("USD"),
        imageCount: z.literal(3),
        automaticRepairCount: z.literal(0),
        priceMeaning: z.literal("MAXIMUM_RESERVATION_NOT_EXPECTED_OR_PROVIDER_GUARANTEED_COST"),
    })
        .strict(),
    allowance: z
        .object({
        revision: z.number().int().nonnegative(),
        actualCostMicros: micros,
        reservedCostMicros: micros,
        remainingCostMicros: micros,
        mandatoryArtworkReserveMicros: micros,
    })
        .strict(),
    evidence: bedtimeRepresentativeProofEvidenceV1Schema,
    selectedProofs: z
        .array(z
        .object({
        turnId: z.string().trim().min(1).max(240),
        mediaSurfaceId: z.string().trim().min(1).max(240),
        topology: z.enum(["SINGLE_PAGE", "FACING_SPREAD", "SPOT", "SEQUENTIAL_REGIONS"]),
        widthPixels: z.number().int().positive(),
        heightPixels: z.number().int().positive(),
        targetDpi: z.number().int().positive(),
    })
        .strict())
        .length(3),
    command: bedtimePublicationGenerationCommandSchema.refine((command) => command.action === "REPRESENTATIVE_LAYOUT_PROOFS", "The offer authorizes only the three reviewed representative pictures."),
})
    .strict()
    .superRefine((offer, context) => {
    const { command, quote, allowance, evidence } = offer;
    if (command.expectedBookRevision !== offer.bookRevision ||
        command.expectedPlanDigestSha256 !== offer.planDigestSha256 ||
        command.quoteId !== quote.quoteId ||
        command.quotedCostMicros !== quote.quotedCostMicros ||
        command.expectedAllowanceRevision !== allowance.revision ||
        command.proofCount !== 3 ||
        command.zeroSpendCompilationDigestSha256 !== evidence.zeroSpendCompilationDigestSha256 ||
        command.studioPlanPreviewDigestSha256 !== evidence.studioPlanPreviewDigestSha256 ||
        command.existingArtProofDigestSha256 !== evidence.existingArtProofDigestSha256)
        context.addIssue({
            code: "custom",
            path: ["command"],
            message: "The command must match this exact source, quote, allowance and evidence.",
        });
});
export const bedtimeRepresentativeProofOfferResponseV1Schema = z
    .object({
    offer: bedtimeRepresentativeProofOfferV1Schema.nullable(),
    blockingDiagnostics: z.array(z
        .object({ code: z.string().min(1).max(160), message: z.string().min(1).max(2_000) })
        .strict()),
    providerDispatchAuthorized: z.literal(false),
})
    .strict();
//# sourceMappingURL=bedtime-representative-proof-offer.js.map